const roles = [
  { id: 1, name: 'Administrador' },
  { id: 2, name: 'Operario en terreno' },
  { id: 3, name: 'Supervisor' },
  { id: 4, name: 'Capataz' },
  { id: 5, name: 'Director Técnico' }
]

export default roles
